import { Injectable } from '@angular/core';

@Injectable()
export class StateModel {
  public toState: any;
  public toStateParams: any;
  public returnToState: any;
  public returnToStateParams: any;
}
